<template>

  <div
    style="width: 100%"
    class="col-12"
  >
     <b-row class="pl-0"
      > <b-form-group
        class="col-3 required-control"
        :disabled="!editable"
        > <label class="font-weight-bold">{{ stockSlipDate.label }}:</label> <date-picker
          :placeholder="stockSlipDate.placeholder"
          class="mb-2 mt-2 form-control form-control-sm"
          :config="dpConfigs.date"
          v-model="stockSlip.stockSlipDate"
          :disabled="!editable"
          aria-describedby="input-date-feedback"
        ></date-picker
        > <b-form-invalid-feedback v-if="!stockSlip.validateState"
          > {{ stockSlipDate.helpText }} </b-form-invalid-feedback
        > </b-form-group
      > <b-form-group
        class="col-3"
        :disabled="!editable || stockSlip.id"
        > <label
          > <span>{{ stockSlipType.label }}:</span> </label
        > <b-form-select
          class="mt-2 select-style"
          size="sm"
          v-model="stockSlip.type"
          :options="stockSlipOptions"
        ></b-form-select
        > </b-form-group
      > <b-form-group
        class="col-3"
        :disabled="!editable"
        > <label style="margin-bottom: 0.75rem">Chiết khấu:</label> <b-row
          > <b-col
            class="pr-0"
            cols="5"
            > <b-form-select
              class="select-style"
              v-model="stockSlip.discountType"
              :options="listAmountType"
              size="sm"
              value-field="id"
              text-field="name"
              > </b-form-select
            > </b-col
          > <b-col
            class="pl-0"
            cols="7"
            > <b-form-input
              class="input-style text-right"
              size="sm"
              v-model="stockSlip.discountAmount"
              v-mask="formater.currency"
              placeholder="Chiết khấu"
            ></b-form-input
            > </b-col
          > </b-row
        > </b-form-group
      > <b-form-group
        class="col-3"
        :disabled="!editable"
        > <label>VAT:</label> <b-row
          > <b-col
            class="pr-0"
            cols="5"
            > <b-form-select
              class="select-style"
              v-model="stockSlip.vatType"
              :options="listAmountType"
              size="sm"
              value-field="id"
              text-field="name"
              > </b-form-select
            > </b-col
          > <b-col
            class="pl-0"
            cols="7"
            > <b-form-input
              class="input-style text-right"
              size="sm"
              type="text"
              v-model="stockSlip.vatAmount"
              v-mask="formater.currency"
              placeholder="VAT"
            ></b-form-input
            > </b-col
          > </b-row
        > </b-form-group
      > </b-row
    > <b-row
      > <b-form-group
        class="col-3 required-control"
        :disabled="isStoreDisabled"
        > <label class="font-weight-bold">Kho:</label> <Autosuggest
          class="border-radius-none mt-2"
          :model="stockSlip.storeName"
          :suggestions="stores"
          placeholder="Kho"
          :limit="200"
          :disabled="isStoreDisabled"
          @select="onSelectedStore"
          @change="onInputChangeStore"
          suggestionName="name"
        /> </b-form-group
      > <b-form-group
        class="col-3 required-control"
        :class="{ invisible: isHideProvider }"
        :style="isHideProvider ? { pointerEvents: 'none' } : {}"
        :disabled="!editable"
        > <label class="font-weight-bold">Nhà cung cấp:</label>
        <div class="float-right">
           <span @click="showAddProvider()"
            ><i
              class="fa fa-plus-circle text-primary pt-1"
              style="cursor: pointer"
            ></i></span
          >
        </div>
         <Autosuggest
          class="border-radius-none mt-2"
          :model="stockSlip.providerName"
          :suggestions="providers"
          placeholder="nhà cung cấp"
          :limit="10"
          @select="onSelectedProvider"
          @change="onInputChangeProvider"
          :suggestionName="providerLabelField || 'fullName'"
          :errorMessages="'Yêu cầu chọn nhà cung cấp'"
        /> </b-form-group
      > <b-form-group class="col-3"
        > <template> <span>Tổng tiền:</span> </template>
        <p class="mt-2 text-right"> {{ convertPrice(totalPrice) }} </p>
         </b-form-group
      > <b-form-group
        class="col-3 required-control"
        :disabled="!editable"
        > <label class="font-weight-bold">Kí hiệu:</label> <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="stockSlip.vatSerial"
          placeholder="Số ký hiệu"
        ></b-form-input
        > </b-form-group
      > </b-row
    > 

    <b-row v-if="isImportFromProvider">
      <b-col md="6">
        <b-form-group :disabled="!editable">
          <label>Nhà cung cấp phụ:</label>
          <SupplierAutosuggest
            v-model="stockSlip.subProviderId"
            :initialLabel="stockSlip.subProviderName"
            placeholder="nhà cung cấp phụ"
            @selected="onSelectedSubProvider"
            :query-params="subProviderQueryParams"
            @input="(val) => { if(!val) onSelectedSubProvider(null) }"
            :disabled="!stockSlip.providerId"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row
      > <b-form-group
        class="col-6"
        :disabled="!editable"
        > <label>Ghi chú:</label> <b-form-textarea
          size="sm"
          v-model="stockSlip.notes"
          :placeholder="'Thêm nội dung ghi chú...'"
          :rows="6"
          :max-rows="6"
        ></b-form-textarea
        > </b-form-group
      > <b-col md="3"></b-col> <b-col md="3"
        > <b-form-group :disabled="!editable"
          > <label>Số hóa đơn VAT:</label> <b-form-input
            class="input-style"
            size="sm"
            type="text"
            v-model="stockSlip.vatCode"
            placeholder="Số hóa đơn VAT"
          ></b-form-input
          > </b-form-group
        > <b-form-group
          :label="'Ngày xuất VAT'"
          :disabled="!editable"
          > <date-picker
            placeholder="Chọn ngày xuất VAT"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="stockSlip.vatDate"
          ></date-picker
          > </b-form-group
        > </b-col
      > </b-row
    > <b-row v-if="(reasons || []).length"
      > <b-col cols="3"
        > <b-form-group class="required-control"
          > <label class="font-weight-bold">Lý do:</label> <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.reasonName"
            :suggestions="reasons || []"
            placeholder="Lý do"
            :limit="200"
            :show-clear="true"
            :clear-on-change="true"
            @select="onSelectedReason"
            @change="onInputChangeReason"
            suggestionName="name"
            :disabled="!editable"
          /> </b-form-group
        > </b-col
      > </b-row
    > <AddProviderModal @onFetchProvider="fetchProvider" />
  </div>

</template>

<script>
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import { validationMixin } from 'vuelidate'
  import required from 'vuelidate/lib/validators/required'
  import { currencyMask, convertPrice, calculateAmountWithVAT } from '@/utils/common'
  import { AMOUNT_TYPE, STOCK_SLIP_TYPE } from '@/utils/enum'
  import AddProviderModal from '../providers/AddProviderModal.vue'
  import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue'

  export default {
    mixins: [validationMixin],
    props: [
      'stockSlip',
      'stores',
      'providers',
      'stockSlipOptions',
      'editable',
      'isHideProvider',
      'reasons',
      'providerApiUrl',
      'providerLabelField',
    ],
    created() {
      const exportStockTypes = [
        STOCK_SLIP_TYPE.EXPORT_PROVIDER,
        STOCK_SLIP_TYPE.EXPORT_HKD,
        STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL,
      ]
      if (exportStockTypes.includes(this.stockSlip.type)) {
        this.stockSlipDate = {
          label: 'Ngày xuất kho',
          placeholder: 'Chọn ngày xuất kho',
          helpText: 'Vui lòng chọn ngày xuất kho',
        }
        this.stockSlipType = {
          label: 'Loại xuất kho',
        }
      }
    },
    data() {
      return {
        dpConfigs: {
          date: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        stockSlipDate: {
          label: 'Ngày nhập kho',
          placeholder: 'Chọn ngày nhập kho',
          helpText: 'Vui lòng chọn ngày nhập kho',
        },
        stockSlipType: {
          label: 'Loại nhập kho',
        },
        listAmountType: [
          {
            id: 1,
            name: 'Tiền mặt',
          },
          {
            id: 2,
            name: '%',
          },
        ],
        formater: {
          currency: currencyMask,
        },
      }
    },
    validations: {
      form: {
        stockSlipDate: { required },
      },
      searchStore: { required },
    },
    components: { Autosuggest, AddProviderModal, SupplierAutosuggest },
    computed: {
      isStoreDisabled() {
        return !this.editable || !!this.stockSlip.id
      },
      isImportFromProvider() {
        return this.stockSlip.type === STOCK_SLIP_TYPE.IMPORT_PROVIDER
      },
      subProviderQueryParams() {
        return this.stockSlip.providerId ? { parentId: this.stockSlip.providerId } : {}
      },
      totalPrice() {
        let total = 0
        for (let index = 0; index < this.stockSlip.details.length; index++) {
          const element = this.stockSlip.details[index]
          const afterVatUnitPrice =
            element.afterVatPriceMask != null
              ? Number(element.afterVatPriceMask) || 0
              : Math.round(
                  calculateAmountWithVAT(element.productPriceMask, element.vatAmount),
                )
          total +=
            afterVatUnitPrice * Number(element.quantity || 0) -
            Number(element.discountAmount || 0)
        }

        const discountValue = this.stockSlip.discountAmount ? this.stockSlip.discountAmount : 0
        let discountAmount = discountValue
        if (this.stockSlip.discountType === AMOUNT_TYPE.PERCENT) {
          discountAmount = (discountValue * total) / 100
        }

        total = total - discountAmount
        const vatValue = this.stockSlip.vatAmount ? this.stockSlip.vatAmount : 0

        let vatAmount = vatValue
        if (this.stockSlip.vatType === AMOUNT_TYPE.PERCENT) {
          vatAmount = (vatValue * total) / 100
        }

        total = Number(total) + Number(vatAmount)
        return Math.round(total)
      },
    },
    methods: {
      convertPrice,
      onSelectedStore(data) {
        this.$emit('onSelectedStore', data)
      },
      onInputChangeStore(data) {
        this.$emit('onInputChangeStore', data)
      },
      onSelectedProvider(data) {
        this.$emit('onSelectedProvider', data)
      },
      onSelectedSubProvider(item) {
        if (item) {
          this.stockSlip.subProviderId = item.id
          this.stockSlip.subProviderName = item.fullName || item.name
        } else {
          this.stockSlip.subProviderId = null
          this.stockSlip.subProviderName = ''
        }
      },
      onInputChangeProvider(text) {
        this.$emit('onInputChangeProvider', text)
      },
      onSelectedReason(data) {
        this.$emit('onSelectedReason', data)
      },
      onInputChangeReason(data) {
        this.$emit('onInputChangeReason', data)
      },
      showAddProvider() {
        this.$bvModal.show('modal-add-provider')
      },
      fetchProvider() {
        this.$emit('onFetchProvider')
      },
    },
  }
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
  .center-label label {
  margin-bottom: 0px;
}

.multi-select-wrapper {
  flex: 1 1 auto;
}

.form-group label {
  font-weight: 500;
}
</style>

